import { useEffect } from "react";
import { planCtaUrl } from "./landingAssets";

const useLandingInteractions = () => {
  useEffect(() => {
    const hamburger = document.getElementById("hamburger");
    const navLinks = document.getElementById("navLinks");

    const handleHamburgerClick = () => {
      if (!navLinks || !hamburger) return;
      const isOpen = navLinks.classList.toggle("active");
      hamburger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    };

    const handleAnchorClick = (event) => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || !navLinks) return;

      const target = document.querySelector(anchor.getAttribute("href"));
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      navLinks.classList.remove("active");
      hamburger?.setAttribute("aria-expanded", "false");
    };

    const handleFaqClick = (event) => {
      const button = event.target.closest(".faq-question");
      if (!button) return;

      const item = button.closest(".faq-item");
      const icon = button.querySelector(".faq-icon");
      const isOpen = item?.classList.toggle("active");

      button.setAttribute("aria-expanded", isOpen ? "true" : "false");
      if (icon) icon.textContent = "+";
    };

    const handlePixelClick = (event) => {
      const trigger = event.target.closest("[data-fb-event]");
      if (!trigger) return;

      const eventName = trigger.dataset.fbEvent;
      const plan = trigger.dataset.plan;
      const value = trigger.dataset.value;
      const params = {};

      if (plan) params.content_name = plan;
      if (eventName === "InitiateCheckout" && value !== undefined) {
        params.value = Number(value);
        params.currency = "USD";
      }

      // Los <button> de plan no tienen destino propio, así que los navegamos acá.
      // Enterprise quedó fuera: es un <a> con href real y navega solo.
      if (trigger.tagName === "BUTTON" && trigger.classList.contains("plan-btn")) {
        window.open(planCtaUrl(plan), "_blank", "noopener");
      }

      if (window.fbq) {
        window.fbq("track", eventName, params);
      }
    };

    const handleDocumentClick = (event) => {
      if (!navLinks?.classList.contains("active")) return;
      if (navLinks.contains(event.target) || hamburger?.contains(event.target)) {
        return;
      }

      navLinks.classList.remove("active");
      hamburger?.setAttribute("aria-expanded", "false");
    };

    // Scroll al fragmento cuando se llega desde otra ruta (ej. /#planes desde
    // /contacto-ventas). React Router no procesa el hash por su cuenta, y el
    // salto nativo tampoco sirve: la landing todavía no está montada cuando el
    // navegador lo intentaría. Se hace a mano una vez montada.
    //
    // 'instant' y no 'auto': con `scroll-behavior: smooth` en el CSS, 'auto'
    // hereda ese valor y la animación de varios miles de píxeles se corta a los
    // pocos píxeles.
    //
    // Sin requestAnimationFrame: el navegador lo suspende mientras la pestaña no
    // está visible, así que el salto no ocurriría al abrir el link en una pestaña
    // de fondo (ctrl+click). El segundo intento cubre los reacomodos tardíos de
    // layout, como una imagen que termina de cargar y empuja la sección.
    let hashScrollTimer;
    if (window.location.hash) {
      let hashTarget = null;
      try {
        hashTarget = document.querySelector(window.location.hash);
      } catch (_) {
        hashTarget = null; // hash que no es un selector válido
      }
      if (hashTarget) {
        const jumpToHash = () =>
          hashTarget.scrollIntoView({ behavior: "instant", block: "start" });
        jumpToHash();
        hashScrollTimer = setTimeout(jumpToHash, 250);
      }
    }

    hamburger?.addEventListener("click", handleHamburgerClick);
    document.addEventListener("click", handleAnchorClick);
    document.addEventListener("click", handleFaqClick);
    document.addEventListener("click", handlePixelClick);
    document.addEventListener("click", handleDocumentClick);

    return () => {
      if (hashScrollTimer) clearTimeout(hashScrollTimer);
      hamburger?.removeEventListener("click", handleHamburgerClick);
      document.removeEventListener("click", handleAnchorClick);
      document.removeEventListener("click", handleFaqClick);
      document.removeEventListener("click", handlePixelClick);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);
};

export default useLandingInteractions;
